import {createTheme} from "@material-ui/core/styles"

export const primary = "#004058"
export const secondary = "rgb(0, 159, 223)"
export const screenBackground = "#F2F2F2"
export const grey = "#D1D5DB"
export const success = "#27ae60"
export const lineColor = grey
export const darkGrey = "#6B727D"
export const error = "#B26065"
export const primaryGrey = "#6b727d"
export const primaryGreyHalf = "rgba($primarygrey, 0.5)"
export const primaryGreyHalfQuarter = "rgba($primarygrey, 0.25)"

export const small = "0.8rem"
export const medium = "1rem"
export const large = "1.85rem"

export const theme = createTheme({
  palette: {
    primary: {
      main: primary
    },
    secondary: {
      main: secondary
    }
  },
  typography: {
    allVariants: {
      color: primary
    },
    subtitle1: {
      fontSize: small,
      color: primaryGrey
    },
    body1: {
      fontSize: medium,
      color: primaryGrey
    },
    h2: {
      fontSize: "1.1rem",
      color: primary
    },
    h6: {
      fontSize: medium,
      color: primary,
      fontWeight: 500
    },
    button: {
      color: primary
    }
  },
  overrides: {
    // Style sheet name ⚛️
    MuiFab: {
      // Name of the rule
      root: {
        boxShadow: 0
      }
    },
    MuiDialogTitle: {
      root: {
        padding: 0,
        marginBottom: 20
      }
    },
    MuiDialog: {
      paper: {
        padding: 20
      }
    },
    MuiTableCell: {
      root: {
        fontSize: medium
      },
      head: {
        color: primary,
        fontFamily: "Roboto Slab, serif"
      }
    }
  }
})



// WEBPACK FOOTER //
// ./src/helpers/theme.js